import React from "react";
import ReactDOM from "react-dom/client";
import { initSentry } from "./lib/sentry";
import { App } from "./App";
import "./index.css";

// Initialise Sentry before React renders so render-time errors are captured.
initSentry();

// Recover gracefully when a lazy chunk can't be fetched - typically
// because the user had the SPA open across a deploy and the chunk
// URL they cached got a new hash. We reload once per session so the
// user gets the fresh index.html and its new chunk URLs.
function installChunkLoadReload() {
  if (typeof window === "undefined") return;
  const KEY = "whistll.chunk-reload-attempted";
  const shouldReload = (reason: unknown) => {
    const msg = String(reason ?? "");
    return (
      msg.includes("Failed to fetch dynamically imported module") ||
      msg.includes("Loading chunk") ||
      msg.includes("Importing a module script failed")
    );
  };
  const maybeReload = (reason: unknown) => {
    if (!shouldReload(reason)) return;
    if (sessionStorage.getItem(KEY)) return; // only once per session
    sessionStorage.setItem(KEY, "1");
    window.location.reload();
  };
  window.addEventListener("error", (e) => maybeReload(e.message));
  window.addEventListener("unhandledrejection", (e) =>
    maybeReload(e.reason?.message ?? e.reason),
  );
}
installChunkLoadReload();

const root = document.getElementById("root");
if (!root) {
  throw new Error("Root container #root not found in index.html");
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
